import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

class SliderTrusted {

    init = (lazy) => {
        const container = document.querySelector('.slider-trusted-us');
        const sliderContainer = container.querySelector('.splide');
        const splide = new Splide( sliderContainer, {
            autoWidth: true,
            pagination: false,
            focus: "center",
            gap: "40px",
            arrows: false,
            type   : 'loop',
            drag   : 'free',
            autoScroll: {
                speed: 1,
            },
        })

        splide.on( 'mounted', function () {
            lazy.update()
        } );

        splide.mount( { AutoScroll } );
    }
}

export default SliderTrusted;